import { defineComponent as Z, computed as o, ref as N, watch as j, createElementBlock as g, openBlock as p, createElementVNode as v, createCommentVNode as D, createBlock as z, normalizeClass as b, toDisplayString as h, createVNode as q, mergeProps as G, withModifiers as H, unref as J, withCtx as K } from "vue";
import Q from "../../icons/generated/IconPlus.vue2.js";
import { isEmpty as f } from "../../utils/isEmpty.js";
import { tw as l } from "../../utils/tailwind.js";
import ee from "../Document/Document.vue2.js";
import te from "../DocumentList/DocumentList.vue2.js";
import { IMAGE_FILE_PREVIEW_EXTENSIONS as ae, ERROR_EVENT as le } from "./InputFileUpload.constant.js";
import { hasValidExtension as T, getTotalFilesSize as ie } from "./InputFileUpload.helpers.js";
const oe = { class: "relative h-48" }, se = ["for"], re = ["id", "accept", "disabled", "multiple"], ne = ["id"], he = /* @__PURE__ */ Z({
  name: "RevInputFileUpload",
  inheritAttrs: !1,
  __name: "InputFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: () => ["*"] },
    deleteAlternativeText: { default: "" },
    description: { default: "" },
    disabled: { type: Boolean, default: () => !1 },
    id: {},
    errors: { default: () => [] },
    labelEmpty: {},
    labelNotEmpty: { default: "" },
    maxFiles: { default: Number.POSITIVE_INFINITY },
    maxFileSize: { default: Number.POSITIVE_INFINITY },
    maxFilesSize: { default: Number.POSITIVE_INFINITY },
    minFileSize: { default: 0 },
    disableImagePreview: { type: Boolean, default: !1 },
    filePreviewDisplay: { default: "inline" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["errors", "update:modelValue"],
  setup(d, { emit: A }) {
    const e = d, E = A, C = o(() => !f(e.modelValue)), P = o(() => C.value && !f(e.labelNotEmpty) ? e.labelNotEmpty : e.labelEmpty), M = o(() => e.accept.join()), R = o(() => !f(e.description)), c = o(() => !f(e.errors)), $ = o(() => {
      if (c.value)
        return `${e.id}_error`;
    }), m = N([]);
    function k(i) {
      return new Promise((n, a) => {
        const t = new FileReader();
        t.onload = () => n(t.result), t.onerror = () => a(new Error(`Failed to read file: ${i.name}`)), t.readAsDataURL(i);
      });
    }
    j(
      () => e.modelValue,
      async (i) => {
        if (!i || !i.length) {
          m.value = [];
          return;
        }
        try {
          const n = await Promise.all(
            i.map(async (a, t) => ({
              file: a,
              previewUrl: await k(a),
              isImage: T(a, ae),
              key: `${a.name}_${a.size}_${t}`
            }))
          );
          m.value = n;
        } catch {
          m.value = [];
        }
      },
      { immediate: !0 }
    );
    const X = o(() => e.modelValue ? e.modelValue.length >= e.maxFiles : !1), s = o(() => e.disabled || X.value), L = o(() => [
      l`body-2 mt-8`,
      !c.value && !s.value && l`text-static-default-low`,
      c.value && !s.value && l`text-static-danger-hi`,
      s.value && l`text-static-default-low-disabled`
    ]), O = o(() => [
      l`peer body-1 absolute inset-0 items-center py-12 pl-12 pr-52`,
      /* In case of a lengthy label, hide the rest of the label under an ellipsis. */
      l`inline max-w-full truncate`,
      s.value ? l`text-action-default-hi-disabled cursor-default` : l`text-action-default-hi cursor-pointer`
    ]), U = o(() => [
      l`rounded-sm flex size-full items-center justify-end border border-solid`,
      l`motion-safe:transition-colors motion-safe:duration-200`,
      !s.value && l`bg-static-default-low peer-hover:bg-static-default-low-hover`,
      !c.value && !s.value && l`border-action-default-low focus-within:border-action-default-low-focus focus-within:outline-default-low`,
      c.value && !s.value && l`border-action-danger-low focus-within:border-action-danger-low-focus focus-within:outline-danger-low`,
      s.value && l`bg-static-default-low-disabled border-action-default-low-disabled`
    ]), B = o(() => e.maxFiles > 1), F = N(null);
    function W(i) {
      const a = i.target.files, t = [];
      let u = [...e.modelValue];
      Array.from(a).forEach((r) => {
        const w = ie([...u, r]), I = w <= e.maxFilesSize;
        I || t.push({
          meta: { totalFilesSize: w },
          type: "MAX_FILES_SIZE_EXCEEDED"
        });
        const y = u.length < e.maxFiles;
        y || t.push({
          meta: { filename: r.name },
          type: "MAX_FILES_EXCEEDED"
        });
        const x = r.size < e.maxFileSize;
        x || t.push({
          meta: { filename: r.name },
          type: "MAX_FILE_SIZE_EXCEEDED"
        });
        const V = e.minFileSize < r.size;
        V || t.push({
          meta: { filename: r.name },
          type: "MIN_FILE_SIZE_NOT_EXCEEDED"
        });
        const S = T(r, e.accept);
        S || t.push({
          meta: { filename: r.name },
          type: "WRONG_FILE_EXTENSION"
        }), I && y && x && V && S && (u = [...u, r]);
      }), f(t) || E(le, t), E("update:modelValue", u);
      const _ = F.value;
      _ && (_.value = "");
    }
    function Y(i) {
      const n = [
        ...e.modelValue.slice(0, i),
        ...e.modelValue.slice(i + 1)
      ];
      E("update:modelValue", n);
    }
    return (i, n) => (p(), g("div", null, [
      v("div", oe, [
        v("label", {
          class: b(O.value),
          for: d.id
        }, h(P.value) + h(d.required ? " *" : ""), 11, se),
        v("div", {
          class: b(U.value)
        }, [
          v("input", G(i.$attrs, {
            id: d.id,
            ref_key: "input",
            ref: F,
            accept: M.value,
            class: "peer absolute z-[-1] opacity-0",
            disabled: s.value,
            multiple: B.value,
            type: "file",
            onChange: H(W, ["prevent"])
          }), null, 16, re),
          q(J(Q), {
            "aria-hidden": "true",
            class: "text-static-default-low ml-16 mr-12 h-32 peer-disabled:text-static-default-low-disabled"
          })
        ], 2)
      ]),
      R.value ? (p(), g("p", {
        key: 0,
        id: $.value,
        class: b(L.value)
      }, h(d.description), 11, ne)) : D("", !0),
      m.value.length ? (p(), z(te, {
        key: 1,
        class: "max-w-[912px]",
        documents: m.value,
        variant: e.filePreviewDisplay
      }, {
        item: K(({ document: a, index: t }) => [
          (p(), z(ee, {
            key: a.key,
            deletable: "",
            "delete-button-aria-label": e.deleteAlternativeText,
            name: a.file.name,
            thumbnail: a.isImage && !e.disableImagePreview,
            url: a.previewUrl,
            onDelete: (u) => Y(t)
          }, null, 8, ["delete-button-aria-label", "name", "thumbnail", "url", "onDelete"]))
        ]),
        _: 1
      }, 8, ["documents", "variant"])) : D("", !0)
    ]));
  }
});
export {
  he as default
};
